import { ILineChartLine, ILineChartSettings } from '@/pages/Dashboards/Charts/LineChart/lineChart.types.ts'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import SeparateLine from '@/shared/Forms/SeparateLine'
import EquipmentDropdown from '@/pages/Equipment/components/Common/EquipmentDropdown'
import ParameterDropdown from '@/pages/Parameters/components/ParameterDropdown'
import ColorDropdown from '@/shared/Inputs/ColorDropdown'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import TrashButton from '@/shared/Buttons/TrashButton'
import { Fragment, useState } from 'react'
import DropdownInput from '@/shared/Inputs/DropdownInput'
import Toggle from '@/shared/Inputs/Toggle'
import NumberInput from '@/shared/Inputs/NumberInput'
import lineChartSettingsConstants from '../lineChartSettings.constants'

interface IProps {
  settings: ILineChartSettings

  onChange: (value: any, key: string) => void
  handleLineDelete: (index: number) => void
  handleLineUpdate: (index: number, value: any, key: string) => void
  handleLineCreate: () => void
}

const LineChartSettingsContent = (props: IProps) => {
  const [maxAndMinChartValuesSettingVisible, setMaxAndMinChartValuesSettingVisible] = useState(
    Boolean(props.settings.minY) || Boolean(props.settings.maxY)
  )

  const handleLimitUpdate = (visible: boolean) => {
    setMaxAndMinChartValuesSettingVisible(visible)

    if (!visible) {
      props.onChange(undefined, 'minY')
      props.onChange(undefined, 'maxY')
    }
  }

  const renderLine = (line: ILineChartLine, index: number) => {
    return (
      <Fragment key={index}>
        <div className="inline-flex-gap gap8 width100" style={{ alignItems: 'flex-end' }}>
          <FormField label="Устройство" fullWidth={true}>
            <EquipmentDropdown
              name="deviceId"
              onChange={(val, name) => props.handleLineUpdate(index, val, name)}
              value={line.deviceId}
            />
          </FormField>
          <FormField label="Переменная" fullWidth={true}>
            <ParameterDropdown
              value={line.parameterId}
              name="parameterId"
              onChange={(val, name) => props.handleLineUpdate(index, val, name)}
            />
          </FormField>
          <ColorDropdown
            value={line.color}
            name="color"
            onChange={(val, name) => props.handleLineUpdate(index, val, name)}
          />
          <TrashButton
            onClick={() => props.handleLineDelete(index)}
            style={{ height: '32px', width: '32px', flexShrink: 0 }}
          />
        </div>
        <SeparateLine />
      </Fragment>
    )
  }

  return (
    <div className="flex-lines gap16" style={{ paddingRight: '24px' }}>
      <FormField label="Наименование" required={true}>
        <TextInput
          value={props.settings.title}
          name="title"
          onChange={props.onChange}
          placeHolder="Введите наименование"
        />
      </FormField>
      <SeparateLine />
      <h4 className="text-heading-4">Конфигурация визуализации</h4>
      <FormField label="Отрисовка линии">
        <DropdownInput
          options={lineChartSettingsConstants.drawType}
          selectedOption={props.settings.lineMode as any}
          title="Выберите опцию"
          onSelect={props.onChange}
          name="lineMode"
        />
      </FormField>
      <div className="inline-flex-gap gap16 mt8">
        <Toggle name="removeExtreme" checked={props.settings.removeExtreme} onChange={props.onChange} size="large" />
        <p className="text-nm">Фильтровать потенциальные пропуски в телеметрии</p>
      </div>
      <div className="inline-flex-gap gap16 mt8">
        <Toggle name="toggle" checked={maxAndMinChartValuesSettingVisible} onChange={handleLimitUpdate} size="large" />
        <p className="text-nm">Задать границы графика по оси ординат</p>
      </div>
      {maxAndMinChartValuesSettingVisible && (
        <div className="inline-flex-gap gap16 width100">
          <FormField label="Нижнее значение" fullWidth={true}>
            <NumberInput value={props.settings.minY} name="minY" onChange={props.onChange} fullWidth={true} />
          </FormField>
          <FormField label="Верхнее значение" fullWidth={true}>
            <NumberInput value={props.settings.maxY} name="maxY" onChange={props.onChange} fullWidth={true} />
          </FormField>
        </div>
      )}
      <SeparateLine />
      <h4 className="text-heading-4">Параметры</h4>
      {props.settings.lines.map(renderLine)}
      <CreateEntityButton onClick={props.handleLineCreate} text="Добавить параметр" type="default" fullWidth={true} />
    </div>
  )
}

export default LineChartSettingsContent
